import React, { useState, useEffect } from 'react';
import { ModalFormSection, ModalV2 } from 'components/common/modals';
import { servicePointsServices } from '@services';
import { showError } from '@utils';
import { useServicePoints } from '@hooks';

import { fieldsName } from './fieldConstants';
import EditServicePointModalForm from './EditServicePointModalForm';

const EditServicePointFieldsModal = ({
  field,
  servicePoint,
  getServicePoint,
  onClose,
  enums,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { invalidateServicePoints } = useServicePoints({ enabled: false });

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const _computedPayload = (form) => {
    let payload = {};

    if (field.name === 'supportedBanks') {
      payload.billingData = {
        bank: form.supportedBanks,
      };
    } else if (field.name === 'bankIban') {
      payload.billingData = {
        bank: servicePoint?.supportedBanks?.value,
        bankIban: form.bankIban,
      };
    } else if (form[field.name] instanceof Array) {
      payload = {
        [field.name]: form[field.name]
          ?.map((item) => item.value)
          ?.sort((a, b) => a - b),
      };
    } else {
      payload = {
        [field.name]: form[field.name],
      };
    }

    return payload;
  };

  const handleSubmit = async (data) => {
    const form = _computedPayload(data);
    try {
      setLoading(true);
      await servicePointsServices?.editServicePoint(servicePoint?.id, form);
      invalidateServicePoints();
      await getServicePoint();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (field) {
      setOpen(true);
    }
  }, [field]);

  return (
    <ModalV2
      id="add-service-point-edit-modal"
      title={`Edit Service Point ${fieldsName[field?.name]}`}
      isOpen={open}
      maxWidth="sm"
      onClose={handleClose}
    >
      <ModalFormSection key={field?.name}>
        {field && (
          <EditServicePointModalForm
            field={field}
            enums={enums}
            onClose={handleClose}
            onSubmit={handleSubmit}
            isSubmitting={loading}
          />
        )}
      </ModalFormSection>
    </ModalV2>
  );
};

const memoizedEditServicePointFieldsModal = React.memo(
  EditServicePointFieldsModal
);
export { memoizedEditServicePointFieldsModal as EditServicePointFieldsModal };

export default memoizedEditServicePointFieldsModal;
